import styled from "styled-components";
import { TabGroup, TabGroupStyles } from "@diana-ui/tab";

export { TabGroupStyles };

export type { ITabGroupRef } from "@diana-ui/tab";

export default styled(TabGroup)``;
